import { useEffect } from 'react';

function isStandaloneDisplay(): boolean {
  if (typeof window === 'undefined') return false;
  const nav = window.navigator as Navigator & { standalone?: boolean };
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches ||
    nav.standalone === true
  );
}

export function useDisplayMode(): boolean {
  useEffect(() => {
    const root = document.documentElement;
    const apply = () => {
      root.dataset.standalone = isStandaloneDisplay() ? 'true' : 'false';
    };
    apply();
    const mq = window.matchMedia('(display-mode: standalone)');
    mq.addEventListener('change', apply);
    return () => mq.removeEventListener('change', apply);
  }, []);

  return isStandaloneDisplay();
}
